import {
  CLEAR_RESULT
} from '@/store/mutation-types'
import { firebaseAction } from 'vuexfire'
// import l from '@/vendor/logger'
import { db } from '@/store'

const state = {
  result: {}
}

const getters = {
  winners (state) {
    if (state.result.winners) {
      return state.result.winners
    }
  }
}

const mutations = {
  [CLEAR_RESULT] (state) {
    state.result = {}
  }
}

const actions = {
  bindResult: firebaseAction(({ bindFirebaseRef, rootState }) => {
    bindFirebaseRef('result', db.ref(`result/${rootState.rid}`))
  }),

  unbindResult: firebaseAction(({ unbindFirebaseRef, rootState, commit }) => {
    unbindFirebaseRef('result', db.ref(`result/${rootState.rid}`))
    db.ref(`result/${rootState.rid}`).off()
    commit(CLEAR_RESULT)
  })
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
